const escapeCSV = (value) => {
  if (value === null || value === undefined) return "";
  return `"${String(value).replace(/"/g, '""')}"`;
};

export const convertToCSV = (rows) => {
  if (!rows.length) return "";

  const headers = Object.keys(rows[0]).map(escapeCSV).join(",");

  const values = rows.map((row) => Object.values(row).map(escapeCSV).join(","));

  return [headers, ...values].join("\n");
};

export const formatRows = (rows) => {
  return rows.map((row) => ({
    serial: row.serial,
    date: new Date(row.date).toLocaleDateString(),
    party: row.party,

    cash: row.cash,

    pc_weight: row.pc?.weight || 0,
    pc_amount: row.pc?.amount || 0,

    lab_weight: row.lab?.weight || 0,
    lab_amount: row.lab?.amount || 0,
    lab_report: row.lab?.report || "",

    bar_weight: row.bar?.weight || 0,
    bar_amount: row.bar?.amount || 0,

    coin_weight: row.coin?.weight || 0,
    coin_amount: row.coin?.amount || 0,
    karat: row.coin?.karat || "",

    ginni_weight: row.ginni?.weight || 0,
    ginni_amount: row.ginni?.amount || 0,
    ginni_report: row.ginni?.report || "",

    silver_weight: row.silver?.weight || 0,
    silver_bar: row.silver?.silverBar || 0,
    silver_amount: row.silver?.amount || 0,

    rwg_weight: row.rwg?.weight || 0,
    rwg_rate: row.rwg?.rate || 0,
    rwg_amount: row.rwg?.amount || 0,

    rws_weight: row.rws?.weight || 0,
    rws_rate: row.rws?.rate || 0,
    rws_amount: row.rws?.amount || 0,
  }));
};

export const formatTotalsRow = (totals) => {
  return {
    serial: "TOTAL",
    date: "",
    party: "",

    cash: totals.cash,

    pc_weight: totals.pc?.weight,
    pc_amount: totals.pc?.amount,

    lab_weight: totals.lab?.weight,
    lab_amount: totals.lab?.amount,
    lab_report: "",

    bar_weight: totals.bar?.weight,
    bar_amount: totals.bar?.amount,

    coin_weight: totals.coin?.weight,
    coin_amount: totals.coin?.amount,
    karat: "",

    ginni_weight: totals.ginni?.weight,
    ginni_amount: totals.ginni?.amount,
    ginni_report: "",

    silver_weight: totals.silver?.weight,
    silver_bar: totals.silver?.silverBar,
    silver_amount: totals.silver?.amount,

    rwg_weight: totals.rwg?.weight,
    rwg_rate: totals.rwg?.rate,
    rwg_amount: totals.rwg?.amount,

    rws_weight: totals.rws?.weight,
    rws_rate: totals.rws?.rate,
    rws_amount: totals.rws?.amount,
  };
};

export const download = (content, fileName = "report.csv") => {
  const blob = new Blob([content], { type: "text/csv;charset=utf-8;" });

  const url = window.URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);

  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
};
